import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from '@ipc/ipc-core';
import { Button, Input } from '@ipc/ipc-components';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { postBalanceOnHandThresholdsEditRequestActionCreator } from '../redux/actions/BalanceOnHandThresholdsEditActions';
import { getClickedRowOnTable } from '../../../../../../common/tables/reducers/selectors/ListTableSelectors';
import { getCheckedRows } from '../../redux/selectors/BalanceOnHandThresholdsSelectors';

class BalanceOnHandThresholdsEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableConfirmButton: true,
      errorMin: '',
      errorMax: '',
      newMinValue: this.props.location.data !== undefined ? this.props.location.data.original.minThreshold : this.props.selectedRows.minThreshold,
      newMaxValue: this.props.location.data !== undefined ? this.props.location.data.original.maxThreshold : this.props.selectedRows.maxThreshold,
    };
    this.handleMinMaxValueChange = this.handleMinMaxValueChange.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  handleMinMaxValueChange = () => {
    const newMinValue = document.getElementById('newMinValue').value;
    const newMaxValue = document.getElementById('newMaxValue').value;

    let errorMin = '';
    let errorMax = '';

    if (newMinValue === '') {
      errorMin = 'Minimum threshold value can not be empty';
    }
    if (newMaxValue === '') {
      errorMax = 'Maximum threshold value can not be empty';
    }
    if (errorMin === '' && parseInt(newMinValue, 0) < 0) {
      errorMin = 'Minimum threshold value can not be negative';
    } else if (errorMax === '' && parseInt(newMinValue, 0) > parseInt(newMaxValue, 0)) {
      errorMin = 'Minimum threshold value can not be greater than maximum';
    }

    const disableConfirmButton = !(errorMin === '' && errorMax === '');

    this.setState({
      newMinValue,
      newMaxValue,
      errorMin,
      errorMax,
      disableConfirmButton,
    });
  }

  getWeekNumbers = () => {
    let weeks = [];
    weeks = this.props.selectedRows.map((row) => row.weekNo);
    return weeks.join(', ');
  }

  getOldMinValue = () => {
    let oldMinValue;
    if (this.props.selectedRows.length !== 1) {
      oldMinValue = 'Multiple Selected';
    } else {
      oldMinValue = this.props.selectedRows[0].minThreshold;
    }

    return oldMinValue;
  }

  getOldMaxValue = () => {
    let oldMaxValue;
    if (this.props.selectedRows.length !== 1) {
      oldMaxValue = 'Multiple Selected';
    } else {
      oldMaxValue = this.props.selectedRows[0].maxThreshold;
    }

    return oldMaxValue;
  }

  confirm = () => {
    let weeks = [];
    let id;
    if (this.props.location.data !== undefined) {
      weeks.push(this.props.location.data.original.weekNo);
      id = this.props.location.data.original.id;
    } else {
      weeks = this.props.selectedRows.map((row) => row.weekNo);
    }
    this.props.postBalanceOnHandThresholdsEditRequestActionCreator(
      this.props.appContext,
      this.props.clickedRow.impc,
      weeks,
      this.state.newMinValue,
      this.state.newMaxValue,
      id,
    );
  };

  render() {
    return (
      <div className="general-content-container">
        <h1 className="title-div">EDIT WEEKLY THRESHOLDS</h1>
        <div>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Operator
                </td>
                <td className="selected-impc">
                  {this.props.clickedRow.operator}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  IMPC
                </td>
                <td className="selected-impc">
                  {this.props.clickedRow.impc}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Selected Weeks
                </td>
                <td className="selected-impc">
                  {this.props.location.data !== undefined ? this.props.location.data.original.weekNo : this.getWeekNumbers()}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  OLD Min Value
                </td>
                <td className="selected-impc">
                  {this.props.location.data !== undefined ? this.props.location.data.original.minThreshold : this.getOldMinValue()}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  OLD Max Value
                </td>
                <td className="selected-impc">
                  {this.props.location.data !== undefined ? this.props.location.data.original.maxThreshold : this.getOldMaxValue()}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  New Min Value
                </td>
                <td className="selected-impc">
                  <Input
                    id="newMinValue"
                    type="number"
                    defaultValue={this.props.location.data !== undefined ? this.props.location.data.original.minThreshold : this.props.selectedRows.minThreshold}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                    onChange={this.handleMinMaxValueChange}
                    value={this.state.newMinValue}
                  />
                  <p style={{ color: 'red' }}>{this.state.errorMin}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  New Max Value
                </td>
                <td className="selected-impc">
                  <Input
                    id="newMaxValue"
                    type="number"
                    defaultValue={this.props.location.data !== undefined ? this.props.location.data.original.maxThreshold : this.props.selectedRows.maxThreshold}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                    onChange={this.handleMinMaxValueChange}
                    value={this.state.newMaxValue}
                  />
                  <p style={{ color: 'red' }}>{this.state.errorMax}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  <Link to={{ pathname: 'impc-stock-levels', state: { tableId: 'BALANCE_ON_HAND_THRESHOLDS_PAGE' } }}>
                    <Button>Cancel</Button>
                  </Link>
                </td>
                <td className="selected-impc">
                  <Link to={{ pathname: 'impc-stock-levels', state: { tableId: 'BALANCE_ON_HAND_THRESHOLDS_PAGE' } }} onClick={this.confirm}>
                    <Button className={`primary-button-${this.state.disableConfirmButton}`} disabled={this.state.disableConfirmButton}>Confirm</Button>
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
BalanceOnHandThresholdsEditContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  operator: PropTypes.string,
  impc: PropTypes.string,
  postBalanceOnHandThresholdsEditRequestActionCreator: PropTypes.func,
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  clickedRow: PropTypes.objectOf(PropTypes.string),
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    selectedRows: getCheckedRows(state),
    clickedRow: getClickedRowOnTable(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postBalanceOnHandThresholdsEditRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandThresholdsEditContainer);
